import { createContext } from 'react';

export interface ThemeContextValue {
  readonly themeName: string;
  /** Official design-system CSS variables for the active theme (e.g. '--color-primary' → '#4ea8ff') */
  readonly tokens: Readonly<Record<string, string>>;
  readonly theme: 'dark' | 'light';
  readonly toggleTheme: () => void;
  /** Alias for toggleTheme — used by ThemeToggle component */
  readonly toggle: () => void;
  /** Directly set a specific theme mode and persist it */
  readonly setTheme: (mode: 'dark' | 'light') => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
